import loadAmplitude from './amplitude';
import loadHotjar from './hotjar';
import loadSentry from './sentry';
import loadGtm from './gtm';

export default (function loadThirdPartyServices() {
    loadAmplitude();
    loadSentry();
    loadGtm();

    if (process.env.REACT_APP_ENV === 'production') loadHotjar();
})();
